import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { createApp } from 'vue';
import NewProductsList from '../components/RelatedProductsList.vue';

createApp(NewProductsList).mount('#related-products-vue');